'use strict';

class Navigation extends BaseComponent {
	static get templateIdentifier() {
		return '#site-nav';
	};

	static get defaultState() {
		return $.extend(super.defaultState, {
			show: false
		});
	};

	constructor(element, state) {
		super(element, state);
		this._view = $('#navigation_Navigation').html();

		this._props = {
			backUrl: site.instance.state.basePath,
			btn_overview: _t('nav_btn_overview')
		};

		_.bindAll(this, 'show', 'hide', 'onClickMarker');
		return this
	}

	init() {
		this.$nav = $('nav.nav', this.$el);
		this.$marker = $('.marker', this.$el);
		this.$markerLabel = $('.label', this.$marker);
		Utils.ajaxify($('a', this.$el));
		this.$marker.on('click', this.onClickMarker)
		return this;
	}

	update(force = false) {
		if(!_.isEqual(this._internalState, this.state) || force) {
			this.$markerLabel.html(this.state.pageNumber);

			if(_.isNumber(this.state.pageNumber)) this.$marker.removeClass('hidden');
			else this.$marker.addClass('hidden');

			if(this.state.show) this.show();
			else this.hide();

			//then copy state
			this._internalState = _.clone(this.state);
		}
		return this;
	}

	show() {
		this.$nav.removeClass('nav-collapsed');
		return this;
	}

	hide() {
		this.$nav.addClass('nav-collapsed');
		return this;
	}

	onClickMarker(){
		site.instance.reloadPage();
	}
}


if(!_.isObjectLike(site)) var site = {components:{}};
site.components.Navigation = Navigation;
